import * as yup from 'yup'

export const validationSchema = yup.object({
  email: yup.string().email().required('Field is required'),

  password: yup.string().required('Field is required'),
})
